import AppConstants from '@/common/constants/app.constants';

/* eslint-disable @typescript-eslint/no-explicit-any */
export default class CommonUtil {
  static isValidParameter = (...params: any) => {
    return params.every(CommonUtil.isNotNullAndUndefined) as Array<NonNullable<any>>;
  };

  static isNotNullAndUndefined = (obj: any) => obj !== null && obj !== undefined;

  static playSound = (sound: string) => {
    const audio = new Audio(sound);
    audio.play();
  };

  static playErrorSound() {
    CommonUtil.playSound(AppConstants.ORDER_SOUND_ERROR_PATH);
  }

  static playSuccessSound() {
    CommonUtil.playSound(AppConstants.ORDER_SOUND_SUCCESS_PATH);
  }

  static playWarningSound() {
    CommonUtil.playSound(AppConstants.ORDER_SOUND_WARNING_PATH);
  }
}
